import * as React from "react";

function PhoneHandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.87 32a17.67 17.67 0 0 1 0-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 26.87a10.41 10.41 0 0 1 0-14.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 30-5.43 5.43a8.77 8.77 0 0 0-2.57 6.2V52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 56h9a3 3 0 0 0 3-3V19a3 3 0 0 0-3-3H31a3 3 0 0 0-3 3v19.33a2 2 0 0 0 3.42 1.42l4.46-4.45a3.23 3.23 0 0 1 4.41-.24 3.12 3.12 0 0 1 .12 4.53l-3.29 3.29a9.83 9.83 0 0 0-2.88 7 6.25 6.25 0 0 1-6.24 6.2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: 52,
    x2: 41,
    y2: 52
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 20,
    x2: 44,
    y2: 20
  }));
}

export default PhoneHandIcon;